import React from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../../common/html/element'
import { DefaultVsicName } from '../../../../DefaultVsicName'
import { ChartGrowthFDI } from './ChartGrowthFDI'
import { ShowDataIndustry } from './ShowDataIndustry'

export const ChartFDI = () => {
  return (
    <div className="w50 h100 flexColumn">
      <div className="flexColumn mb1">
        <Translate
          value="industryOverview.macroeconomics.FDI_CURRENT_PRICE_GROWTH_RATE"
          className="fw600"
        />
        <DefaultVsicName />
      </div>

      <ShowDataIndustry />

      <Element style={{ color: '#9c9c9c', marginTop: 14 }}>
        <Translate value="industryOverview.macroeconomics.FDI_GROWTH_RATE" />
      </Element>

      <div className="flex1" id="macroChartGrowthFDIId">
        <ChartGrowthFDI />
      </div>
    </div>
  )
}
